(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ws-explorer-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    document.querySelectorAll('.ws-nav').forEach(nav => {
      if (nav.dataset.wsReady) return;
      nav.dataset.wsReady = 'true';
      const details = [...nav.querySelectorAll('.ws-nav__details')];
      details.forEach(item => {
        let timer;
        item.querySelector('summary').addEventListener('click', e => {
          if (e.detail > 0 && window.matchMedia('(hover: hover)').matches) {
            e.preventDefault();
            clearTimeout(timer);
            details.forEach(other => { if (other !== item) other.open = false; });
            item.open = true;
          }
        });
        item.addEventListener('toggle', () => {
          if (item.open) details.forEach(other => { if (other !== item) other.open = false; });
        });
        item.addEventListener('pointerenter', e => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(timer);
          details.forEach(other => { if (other !== item) other.open = false; });
          item.open = true;
        });
        item.addEventListener('pointerleave', e => {
          if (e.pointerType === 'mouse') timer = setTimeout(() => { if (!item.contains(document.activeElement)) item.open = false; }, 180);
        });
        item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) item.open = false; });
      });
      nav.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          const open = details.find(item => item.open);
          if (open) { open.open = false; open.querySelector('summary').focus(); e.preventDefault(); }
        }
      });
      document.addEventListener('pointerdown', e => { if (!nav.contains(e.target)) details.forEach(item => { item.open = false; }); });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ws-product-improvements"] && !Shopify.designMode) return;
  try {
    (() => {
 const init = () => {
  document.querySelectorAll('.ws-product-extras').forEach(extras => {
   if (extras.dataset.ready) return;
   extras.dataset.ready='true';
   const scope=extras.closest('.product__info-container') || extras.closest('.product__info-wrapper');
   if (!scope) return;
   const moveOffers=()=>{
    scope.querySelectorAll('.mpb-offer--volume_discount').forEach(offer=>{
     const slot=extras.querySelector('.ws-volume-offer');
     if(slot && offer.parentElement!==slot) slot.append(offer);
    });
   };
   const observer=new MutationObserver(moveOffers);
   observer.observe(scope,{childList:true,subtree:true});
   moveOffers();
  });
 };
 init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
